/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import FileExtension from "./Basis/Components/FileUploadBase/FileExtensions";

export default class UIConstants {
    public static readonly maxImgSize = 256;
    public static readonly maxImgSizePx = `${UIConstants.maxImgSize}px`;
    public static readonly ui = "ui";
    public static readonly api = "api";
    public static readonly restApi = "restapi/v1";
    public static readonly nimm: number = 300;
    public static readonly nimmAutocomplete = 25;
    // 5MB
    public static readonly maxFileSize = 5 * 1024 * 1024;
    public static readonly maxFiles = 50
    public static readonly int32MaxValue: number = 2147483647;
    public static readonly apiPath = "/_/api";
    public static readonly credentials = "same-origin";
    public static readonly uiSysPath = "_";
    public static readonly standardWaehrung = "EUR";
    // Kultur: https://stackoverflow.com/questions/8199760/how-to-get-the-browser-language-using-javascript
    public static readonly kultur = navigator.language;
    public static readonly kulturShortLower = navigator.language.substring(0, 2).toLowerCase();
    // Zeitzone: https://stackoverflow.com/questions/9772955/how-can-i-get-the-timezone-name-in-javascript
    public static readonly zeitzone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    public static readonly agbUrl = "https://lansoftware.de/agb/";
    public static readonly docsUrl = "https://docs.LANcloud.cloud";
    public static readonly homepageUrl = "https://www.LANcloud.cloud";
    public static readonly blogUrl = `${UIConstants.docsUrl}/blog.html`;
    public static readonly faqUrl = `${UIConstants.docsUrl}/docs/faq/main`;
    public static readonly feedbackUrl = "https://lancloud.upvotyfeedback.com/";
    public static readonly datenschutzUrl = "https://lansoftware.de/datenschutz/";
    public static readonly impressumUrl = "https://lansoftware.de/impressum/";
    public static readonly stripeDashboardUrl = "https://dashboard.stripe.com/";
    public static readonly rowsMultilineTextInput = 7;
    public static readonly loginPath = `/_/auth/login`;
    public static readonly logoutPath = `/_/logout`;
    public static readonly registerPath = `/_/auth/registrieren`;
    public static readonly vertriebEMail = "vertrieb@lancloud.cloud";
    public static readonly erlaubteDateiendungenBild: FileExtension[] = [".jpg", ".jpeg", ".png", ".gif", ".svg"];
    public static readonly erlaubteDateiendungenFavicon: FileExtension[] = UIConstants.erlaubteDateiendungenBild.concat([".ico"]);
    public static readonly erlaubteDateiendungenDatei: FileExtension[] = UIConstants.erlaubteDateiendungenFavicon.concat([".pdf", ".docx", ".xlsx", ".pptx"]);
    public static readonly zeigeLoadingNachMillis = 250;
    public static readonly inputDebounceMillis = 300;
}
